import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function SiteLayout({ children, transparentHeader = false }) {
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[1000] focus:bg-terracotta focus:text-cream focus:px-4 focus:py-2 focus:rounded-sm focus:outline-none"
      >
        Saltar al contenido
      </a>
      <Header transparent={transparentHeader} />
      <main id="main" tabIndex={-1}>{children}</main>
      <Footer />
    </>
  );
}
